import React from 'react';
import { Link } from 'react-router-dom';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
   button: {
      backgroundColor: '#27A844',
      color: 'white',
   },
}));

const Download = (props) => {
   const classes = useStyles();
   return (
      <Button
         {...props}
         component={Link}
         variant={'contained'}
         className={classes.button}
         startIcon={<FontAwesomeIcon icon={faFilePdf} size={'xs'} />}
         target='_blank'
      >
         {props.buttonText || 'ดาวน์โหลดไฟล์ PDF'}
      </Button>
   );
};
export default Download;
